import { api } from './client';
import type {
  ContractRegister,
  CorrectContractRequest,
  CorrectContractResponse,
  IngestFinalizeRequest,
  IngestFinalizeResponse,
} from './types';

// The contract register's calls (ADR-0054), shared by every portal; each app wraps
// them in its own react-query hooks under {@link contractsQueryKey}.

export const contractsQueryKey = (roomId: string) => ['rooms', roomId, 'contracts'] as const;

/** GET /rooms/:roomId/contracts — the register over the caller's own visible documents. */
export function fetchContractRegister(roomId: string): Promise<ContractRegister> {
  return api.get<ContractRegister>(`/rooms/${roomId}/contracts`);
}

/** PATCH /rooms/:roomId/contracts/:documentId — a correction (admin / bound seller), audited. */
export function correctContract(
  roomId: string,
  documentId: string,
  body: CorrectContractRequest,
): Promise<CorrectContractResponse> {
  return api.patch<CorrectContractResponse>(`/rooms/${roomId}/contracts/${documentId}`, body);
}

/** POST /rooms/:roomId/contracts/:documentId/current-copy — a new version of the contract. */
export function uploadContractCurrentCopy(
  roomId: string,
  documentId: string,
  body: IngestFinalizeRequest,
): Promise<IngestFinalizeResponse> {
  return api.post<IngestFinalizeResponse>(
    `/rooms/${roomId}/contracts/${documentId}/current-copy`,
    body,
  );
}

/** POST /rooms/:roomId/contracts/rescan — the admin re-reads every contract (202). */
export function rescanContracts(roomId: string): Promise<{ queued: number }> {
  return api.post<{ queued: number }>(`/rooms/${roomId}/contracts/rescan`);
}
